import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { CardActionArea } from "@mui/material";
import "./css/dashbody.css";
import { Data } from "./List/CardsList";
import Box from "@mui/material/Box";
import StarIcon from "@mui/icons-material/Star";
import { height } from "@mui/system";


const BodyDash = () => {
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-sm-12 col-md-9 col-lg-9">
            <h3 className="text-white mt-2 pl-1">Business near me</h3>
            <Box
              sx={{ display: "flex", flexWrap: "wrap", margin: "1rem auto" }}
            >
              {Data.map((item) => (
                <Card sx={{ maxWidth: "14rem", margin: "0.5rem" }}>
                  <CardActionArea>
                    <CardMedia
                      component="img"
                      image={item.image}
                      alt="green iguana"
                      sx={{ width: "100%" }}
                    />
                    <CardContent
                      sx={{ backgroundColor: "#11163A", color: "#fff" }}
                    >
                      <div
                        style={{
                          justifyContent: "space-between",
                          display: "flex",
                        }}
                      >
                        <h6>{item.name}</h6>
                        <button
                          className="btn btn-sm text-white"
                          style={{
                            borderRadius: "25px",
                            backgroundColor: "#050A30",
                          }}
                        >
                          <StarIcon sx={{ fontSize: "13px" }} />
                          {item.rate}
                        </button>
                      </div>
                      <div>
                        <p>{item.para} </p>
                      </div>
                      <div
                        style={{
                          justifyContent: "space-between",
                          display: "flex",
                        }}
                      >
                        <div className="divstyle">{item.ticket} </div>
                        <div>hlo</div>
                      </div>
                      <div className="text-center pt-3">{item.time}</div>
                    </CardContent>
                  </CardActionArea>
                </Card>
              ))}
            </Box>
          </div>
          <div className="col-12 col-sm-12 col-md-3 col-lg-3">
            <div className="m-3 mt-5">
              <img
                src="images/Dashimages/add01.png"
                style={{ width: "100%", objectFit: "cover" }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BodyDash;
